<template>
  <base-loader class="authenticating">
    Authenticating...
  </base-loader>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'auth',

  metaInfo: {
    title: 'Authenticating'
  },

  async mounted () {
    await this.handleAuthentication()

    this.$router.push({ name: 'dashboard' })
  },

  methods: mapActions({
    handleAuthentication: 'core/auth/handleAuthentication'
  })
}
</script>
